import { Box, Icon } from '@zillow/constellation-10';
import {
  IconPauseCircleFilled,
  IconUnconstrainedWalkThroughFilled,
  IconUserAddFilled,
} from '@zillow/constellation-icons';

import { ANSWER_CARD_CONFIG, DEACTIVATION_REASONS, type DeactivationReason } from '../constants';

import { DEACTIVATION_REASON_CLICK_EVENT_ID } from '../../../../analytics/events/tenantDirectory';
import AnswerCard from './AnswerCard';

type DeactivationReasonStepProps = {
  deactivationReason: DeactivationReason | null;
  onAnswerSelect: (answer: DeactivationReason) => void;
};

const getTitle = (reason: DeactivationReason): string =>
  ANSWER_CARD_CONFIG.find((config) => config.reason === reason)?.title ?? '';

const DeactivationReasonStep = ({ deactivationReason, onAnswerSelect }: DeactivationReasonStepProps) => {
  return (
    <Box data-testid="DeactivationReasonStep" css={{ display: 'flex', flexDirection: 'column', gap: 'tight' }}>
      <AnswerCard
        data-testid="AnswerCardFoundTenant"
        data-event-id={DEACTIVATION_REASON_CLICK_EVENT_ID}
        icon={
          <Icon size="lg">
            <IconUserAddFilled />
          </Icon>
        }
        title={getTitle(DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE)}
        isSelected={deactivationReason === DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.FOUND_RENTER_ELSEWHERE)}
      />
      <AnswerCard
        data-testid="AnswerCardTenantRenewed"
        data-event-id={DEACTIVATION_REASON_CLICK_EVENT_ID}
        icon={
          <Icon size="lg">
            <IconUnconstrainedWalkThroughFilled />
          </Icon>
        }
        title={getTitle(DEACTIVATION_REASONS.TENANT_RENEWED)}
        isSelected={deactivationReason === DEACTIVATION_REASONS.TENANT_RENEWED}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.TENANT_RENEWED)}
      />
      <AnswerCard
        data-testid="AnswerCardStillLookingPausing"
        data-event-id={DEACTIVATION_REASON_CLICK_EVENT_ID}
        icon={
          <Icon size="lg">
            <IconPauseCircleFilled />
          </Icon>
        }
        title={getTitle(DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW)}
        isSelected={deactivationReason === DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.STILL_LOOKING_PAUSING_ON_ZILLOW)}
      />
    </Box>
  );
};

export default DeactivationReasonStep;
